// How Settings describes a connected app (#6612). Pure, shared by the connected apps list.
import type { OauthConnection } from '@/lib/types';

const SURFACE_LABELS = { mcp: 'MCP server', api: 'REST API' } as const;

/** What a connection reaches, in words: the MCP server, the REST API, or both, MCP first. */
export function connectionReach(surfaces: OauthConnection['surfaces']): string {
  return (['mcp', 'api'] as const)
    .filter((surface) => surfaces.includes(surface))
    .map((surface) => SURFACE_LABELS[surface])
    .join(' and ');
}
